<template>
  <StyledDiv class="exampleForCathy">
    <NavBar />
    <Splash />
    <InfoGraphic />
    <TedTalkLink />
    <Features />
    <Bottom />
  </StyledDiv>
</template>

<script>
import { StyledDiv } from "./styled";
import Splash from "./components/Splash";
import Features from "./components/Features";
import InfoGraphic from "./components/InfoGraphic";
import Bottom from "./components/Bottom";
import TedTalkLink from "./components/TedTalkLink";
// eslint-disable-next-line
import styles from './global.css';

export default {
  components: {
    StyledDiv,
    TedTalkLink,
    Splash,
    Features,
    Bottom,
    InfoGraphic
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style>
body,
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
.exampleForCathy {
  height: 100%;
}
</style>
